// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g-pr","option":"styles_option__1XIl7","active":"styles_active__MHCrN"};